module.exports = __webpack_public_path__ + "c203b7d419687480f78c042a7113b665.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/sponsors/github.svg
// module id = 49
// module chunks = 0